import { createSlice } from "@reduxjs/toolkit";
import { resetPreferencesSync } from "@sait-fe-core";

const initialState = {
	token: "",
	username: "",
	fctCodSocieta: "",
	fctCodSede: "",
	menu: "",
	ipAddress: "",
	hostname: "",
	idPersona: "",
	dashboard: "",
	flCambioPassword: "",
	sediUtente: [],
	objMod: [],
	ruoliUtente: [],
	linguaIso: "",
	airportCode: "",
	backendVersion: "",
	databasePatch: "",
	databaseVersion: "",
};

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setUserPreferences: (state, action) => {
			state.token = action.payload.token;
			localStorage.setItem("frameToken", action.payload.token);
			state.dashboard = action.payload.userPreferences.dashboard;
			state.username = action.payload.userPreferences.username;
			state.fctCodSocieta = action.payload.userPreferences.fctCodSocieta;
			state.fctCodSede = action.payload.userPreferences.fctCodSede;
			state.menu = action.payload.userPreferences.menu;
			state.ipAddress = action.payload.userPreferences.ipAddress;
			state.hostname = action.payload.userPreferences.hostname;
			state.idPersona = action.payload.userPreferences.idPersona;
			state.flCambioPassword = action.payload.userPreferences.flCambioPassword;
			state.sediUtente = action.payload.userPreferences.sediUtente;
			state.objMod = action.payload.userPreferences.objMod;
			state.ruoliUtente = action.payload.userPreferences.ruoliUtente;
			state.linguaIso = action.payload.userPreferences.linguaIso;
			state.airportCode = action.payload.userPreferences.airportCode;
			state.backendVersion = action.payload.userPreferences.backendVersion;
			state.databasePatch = action.payload.userPreferences.databasePatch;
			state.databaseVersion = action.payload.userPreferences.databaseVersion;
		},
		unsetUserPreferences: (state) => {
			state.token = "";
			localStorage.removeItem("frameToken");
			// Un eventuale nuovo login sulla stessa pagina deve risincronizzare le preferenze
			resetPreferencesSync();
			state.dashboard = "";
			state.username = "";
			state.fctCodSocieta = "";
			state.fctCodSede = "";
			state.menu = "";
			state.ipAddress = "";
			state.hostname = "";
			state.idPersona = "";
			state.flCambioPassword = "";
			state.sediUtente = [];
			state.objMod = [];
			state.ruoliUtente = [];
			state.linguaIso = "";
			state.airportCode = "";
			state.backendVersion = "";
			state.databasePatch = "";
			state.databaseVersion = "";
		},
		passwordCambiata: (state) => {
			state.flCambioPassword = "N";
		},
	},
});

export const { setUserPreferences, unsetUserPreferences, passwordCambiata } = authSlice.actions;

export default authSlice.reducer;
